import { render, staticRenderFns } from "./LayoutDataTable.vue?vue&type=template&id=39631cc8"
import script from "./LayoutDataTable.vue?vue&type=script&lang=js"
export * from "./LayoutDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports